// Marcadores usados no bloco "Foto com marcação". Cada modelo pode definir sua própria paleta de
// ferramentas (label, cor, unidade e formato) em `block.data.markerTypes` — configurado na criação
// do modelo (ver image-annotation-block.svelte). Compartilhado entre o editor (image-annotation-view)
// e a impressão (form-v2-print), para os pontos saírem idênticos nos dois lugares.
export interface MarkerToolConfig {
    id: string
    label: string
    color: string
    unit: string
    /** `arrow` é desenhado com dois cliques (cauda e ponta) em vez de um único ponto. */
    shape: 'dot' | 'arrow'
}

// Paleta padrão — usada quando o modelo ainda não tem `markerTypes` configurado (modelos criados
// antes desta personalização existir) e como ponto de partida ao adicionar o bloco pela primeira vez.
export const DEFAULT_MARKER_TOOLS: MarkerToolConfig[] = [
    { id: 'preenchimento', label: 'Preenchimento', color: '#6a1b9a', unit: 'ml', shape: 'dot' },
    { id: 'botox', label: 'Toxina botulínica', color: '#ff3d00', unit: 'un', shape: 'dot' },
    { id: 'injetavel', label: 'Injetável', color: '#00695c', unit: 'ml', shape: 'dot' },
    { id: 'pdo', label: 'Fio de PDO', color: '#ff9100', unit: 'mm', shape: 'arrow' },
]

export interface AnnotationPoint {
    id: string
    /** Referencia o `id` de um item em `markerTypes` (bloco), não mais um tipo fixo. */
    type: string
    /** Posição do ponto — para marcadores em seta (`shape: 'arrow'`), é a cauda (1º clique). */
    x: number
    y: number
    /** Ponta da seta (2º clique) — só usado quando o marcador é `shape: 'arrow'`. */
    x2?: number
    y2?: number
    value: string
}

export function getMarkerTools(data: { markerTypes?: MarkerToolConfig[] } | null | undefined): MarkerToolConfig[] {
    return data?.markerTypes?.length ? data.markerTypes : DEFAULT_MARKER_TOOLS
}

export function findMarkerTool(tools: MarkerToolConfig[], type: string): MarkerToolConfig {
    return tools.find((t) => t.id === type) ?? tools[0] ?? DEFAULT_MARKER_TOOLS[0]
}
